import { ChartLineUp, Pulse, SquaresFour } from "@phosphor-icons/react"
import { createFileRoute, Outlet } from "@tanstack/react-router"
import { Module } from "~/components/design-system/pages"
import { BreadcrumbWrapper } from "~/components/reusable/Breadcrumb"
import { type HeaderTab } from "~/components/reusable/HeaderTabs"

export const Route = createFileRoute("/_auth/internal/customer-success/_layout")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

const tabs: HeaderTab[] = [
  {
    label: "Overview",
    path: "/internal/customer-success",
    icon: <SquaresFour />,
  },
  {
    label: "Impact",
    path: "/internal/customer-success/impact",
    icon: <ChartLineUp />,
  },
  {
    label: "User Activity",
    path: "/internal/customer-success/user-activity",
    icon: <Pulse />,
  },
  {
    label: "Haki Usage",
    path: "/internal/customer-success/haki-usage",
  },
]

function RouteComponent() {
  return (
    <Module
      breadcrumb={<BreadcrumbWrapper />}
      tabs={{ items: tabs, path: "/internal/customer-success" }}
    >
      <Outlet />
    </Module>
  )
}
